define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FAssetAttr = void 0;
    class FAssetAttr extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "AssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AttrTypeId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AttrTypeIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Value", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ValueError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FAssetAttr.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FAsset = parent;
            this.AssetId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.FAsset = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.AssetId = (0, EntityUtil_1.toInt)(entity.AssetId);
            a.AttrTypeId = (0, EntityUtil_1.toInt)(entity.AttrTypeId);
            a.Value = b.Value;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FAssetAttr.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "AssetId", "Facility Asset Id");
                this.validateReqNumber(validationState, "AttrTypeId", "Asset Attribute Type Id");
                this.validateReqString(validationState, "Value", "Value");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                AssetId: this.AssetId,
                AttrTypeId: this.AttrTypeId,
                Value: this.Value,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static create(a, type) {
            return new Promise((resolve, reject) => {
                var aa = new FAssetAttr(null, a);
                aa.AttrTypeId = type.Id;
                a.FAssetAttr.push(aa);
                resolve(aa);
            });
        }
        get AssetAttributeType() {
            if (this.FAsset && this.FAsset.Facility) {
                return this.FAsset.Facility.AssetAttributeTypes.find(aat => aat.Id == this.AttrTypeId);
            }
            else {
                return null;
            }
        }
        get Description() {
            if (this.AssetAttributeType) {
                return this.AssetAttributeType.Desc_;
            }
        }
    }
    exports.FAssetAttr = FAssetAttr;
    Object.defineProperty(FAssetAttr, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FAssetAttr"
    });
    Object.defineProperty(FAssetAttr, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Asset Attribute"
    });
    Object.defineProperty(FAssetAttr, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "AssetId", "AttrTypeId", "Value"]
    });
    Object.defineProperty(FAssetAttr, "AssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAssetAttr, "AttrTypeIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAssetAttr, "ValueLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FAssetAttr, "ValueReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttr.prototype, "AssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttr.prototype, "AssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttr.prototype, "AttrTypeId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttr.prototype, "AttrTypeIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttr.prototype, "Value", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttr.prototype, "ValueError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttr.prototype, "FAsset", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FAssetAttr.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FAssetAttr.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FAssetAttr.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FAssetAttr.prototype, "AssetAttributeType", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FAssetAttr.prototype, "Description", null);
});
